import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRouteSnapshot } from '@angular/router';

import { RouteTag } from '@frontend/sports/common/core/data-access/route';
import { RouterEventsService } from '@frontend/sports/common/core/utils/router-events';
import { ColumnLayoutService } from '@frontend/sports/layout/feature';
import { toInteger } from 'lodash-es';
import { Observable } from 'rxjs';

import { CompetitionOverview } from '../competition-list/services/competition-list.service';
import { CompetitionService } from '../competition-list/services/competition.service';
import { MasterDetailComponent, MasterDetailDependencyService } from '../dependency/master-detail-dependency.service';
import { TournamentFixtureList, TournamentService } from './tournament.service';

@Injectable({ providedIn: 'root' })
export class TournamentEventsService extends MasterDetailDependencyService<CompetitionOverview, TournamentFixtureList | undefined> {
    constructor(
        private tournamentService: TournamentService,
        private competitionService: CompetitionService,
        private routerEventsService: RouterEventsService,
        public columnLayoutService: ColumnLayoutService,
    ) {
        super(columnLayoutService);

        this.routerEventsService.currentActivationEnd.pipe(takeUntilDestroyed()).subscribe((route) => {
            if (route && route.snapshot.data.tag !== RouteTag.Competition) {
                this.deregister();
            }
        });
    }

    getRouteParams: undefined;

    getData(route: ActivatedRouteSnapshot, detail?: TournamentFixtureList | undefined): Observable<CompetitionOverview | undefined> {
        return this.competitionService.getData(route);
    }

    getPreResolvedData(route: ActivatedRouteSnapshot): Observable<CompetitionOverview | undefined> {
        return this.competitionService.getPreResolvedData(route);
    }

    getDetailData(route: ActivatedRouteSnapshot, master?: CompetitionOverview | undefined): Observable<TournamentFixtureList | undefined> {
        const league = toInteger(route.params.league);

        return this.tournamentService.getFixtureList(route.params.tournament, league);
    }

    getPreResolvedDetailData(route: ActivatedRouteSnapshot): Observable<TournamentFixtureList | undefined> {
        return this.tournamentService.getPreResolveFixtureList(route.params, route.params.tournament, toInteger(route.params.league));
    }

    getComponents(): MasterDetailComponent<CompetitionOverview>[] {
        return this.competitionService.getComponents();
    }

    override shouldUpdateMasterCache(master: CompetitionOverview, route: ActivatedRouteSnapshot): boolean {
        return this.competitionService.shouldUpdateMasterCache(master, route);
    }
}
